module.exports = __webpack_public_path__ + "img/pp-16.451e66d8.jpg";